var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    color: "#363A3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plane",
    clipPath: "url(#clip0_1250_4783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.93333 6.4L5.33333 3.66667L6.5 2.5C7 2 7.16667 1.33333 7 1C6.66667 0.833333 6 1 5.5 1.5L4.33333 2.66667L1.6 2.06667C1.43333 2.03333 1.3 2.1 1.23333 2.23333L1.13333 2.4C1.06667 2.56667 1.1 2.73333 1.23333 2.83333L3 4L2.33333 5H1.33333L1 5.33333L2 6L2.66667 7L3 6.66667V5.66667L4 5L5.16667 6.76667C5.26667 6.9 5.43333 6.93333 5.6 6.86667L5.76667 6.8C5.9 6.7 5.96667 6.56667 5.93333 6.4Z",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_4783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.a26800cb83d83006e8a22c7de3106e3e.svg";
export { ForwardRef as ReactComponent };